/**
 * @param {HTMLElement} section
 */
const initializeBestSellersTabs = (section) => {
  if (section.dataset.bestSellersInitialized === 'true') return;

  const tabs = /** @type {HTMLButtonElement[]} */ ([
    ...section.querySelectorAll('[data-best-sellers-tabs] [role="tab"]'),
  ]);
  const panels = /** @type {HTMLElement[]} */ ([...section.querySelectorAll('[data-best-sellers-panel]')]);
  if (!tabs.length || !panels.length) return;

  section.dataset.bestSellersInitialized = 'true';

  /**
   * @param {number} index
   * @param {boolean} [moveFocus]
   */
  const showPanel = (index, moveFocus = false) => {
    tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });

    const slideshow = panels[index]?.querySelector('slideshow-component');
    /** @type {{ select?: Function } | null} */ (slideshow)?.select?.(0, undefined, { animate: false });

    if (moveFocus) tabs[index]?.focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => showPanel(index));
    tab.addEventListener('keydown', (event) => {
      const keyboardEvent = /** @type {KeyboardEvent} */ (event);
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(keyboardEvent.key)) return;
      keyboardEvent.preventDefault();

      const nextIndex = keyboardEvent.key === 'Home'
        ? 0
        : keyboardEvent.key === 'End'
          ? tabs.length - 1
          : (index + (keyboardEvent.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;

      showPanel(nextIndex, true);
    });
  });

  showPanel(tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true') || 0);
};

/**
 * @param {Document | Element} root
 */
const initializeBestSellersSections = (root = document) => {
  root.querySelectorAll('.featured-prds').forEach((section) => {
    if (section instanceof HTMLElement) initializeBestSellersTabs(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeBestSellersSections(), { once: true });
} else {
  initializeBestSellersSections();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeBestSellersSections(event.target);
});
